module.exports = __webpack_public_path__ + "media/electronic_components_sourcing/arrow-ba29eee2.png";